import { Container } from '../../../odie';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { OctopusBlockProps } from './OctopusBlock';
import { SpineView, spineLoader } from '@play-co/timestep-spine';
import { playSpineAnimation } from 'src/lib/ui/utils/spine';
import { CageBlockView } from '../../views/blocks/CageBlockView';

const assets = {
  all: getMatch2AssetPath('blocks/octopus'),
  spine: {
    loadMethod: spineLoader,
    url: getMatch2AssetPath('blocks/octopus/animation/spine.octopus'),
  },
};

export class OctopusBlockView extends Container {
  private spine?: SpineView;

  constructor(props: OctopusBlockProps) {
    super();
    blockPositionView(this, props);
    this.createSpine();
  }

  public static assets() {
    return [...Object.values(assets), ...CageBlockView.assets()];
  }

  private async createSpine() {
    if (this.spine) return;
    await spineLoader(assets.spine.url);
    this.spine = new SpineView({
      superview: this.view,
      spinePath: assets.spine.url,
    });
    playSpineAnimation(this.spine, { animation: 'idle', loop: true });
  }

  public async playHopAnimation() {
    if (!this.spine) return;
    await playSpineAnimation(this.spine, { animation: 'hop', loop: false });
    playSpineAnimation(this.spine, { animation: 'idle', loop: true });
  }

  public async playSwimAnimation() {
    if (!this.spine) return;
    await playSpineAnimation(this.spine, { animation: 'swim', loop: false });
  }
}

export function _createOctopusBlockView(
  props: OctopusBlockProps,
): OctopusBlockView {
  return new OctopusBlockView(props);
}
